import { z } from "zod";
import { FeatureKey } from "./feature";
import { Permission } from "./permissions";
import { RoleAssignment } from "./role";
import { Tenant } from "./tenant";
import { UserProfile } from "./user";

/**
 * Hydrated principal returned by `GET /me`. The web shell drives the
 * sidebar nav, header, and route guards from this single payload.
 */
export const Me = z.object({
  user: UserProfile,
  tenant: Tenant,
  roles: z.array(RoleAssignment),
  features: z.array(FeatureKey),
  permissions: z.array(Permission),
  isPlatformAdmin: z.boolean(),
});
export type Me = z.infer<typeof Me>;
